import React from "react";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { CTABanner } from "@/components/CTABanner";
import { About } from "@/components/About";
import { FAQ } from "@/components/FAQ";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingBookButton } from "@/components/FloatingBookButton";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Services />
        <CTABanner />
        <About />
        <CTABanner variant="light" />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingBookButton />
      <Toaster />
    </div>
  );
}

export default App;
